import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { setActiveLayout } from "../../helpers/product";
import { Drawer, Select } from "antd";
import { connect } from "react-redux";
import "./newStyle.css";
import ShopSidebar from "../../wrappers/product/ShopSidebar";
import { useHistory, NavLink } from "react-router-dom";

const ShopTopAction = ({
  setFilter,
  filters,
  getLayout,
  getSidebarFilter,
  sidebarFilter,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  layout,
  getItemsPerPage,
  categoryTreeData,
  getSortParams,
  searchTag,
  setSearchTag,
  setSelectedBrands,
  selectedBrands={selectedBrands},
  mapCategoryTreeData
}) => {
  const formRef = useRef();
  const { Option } = Select;
  const [categoryName, setCategoryName] = useState();
  const [visible, setVisible] = useState(false);
  const [orientationButton, setorientationButton] = useState(null); // Tracks the active button
  const [sortByButton, setSortByButton] = useState(null); // Tracks the active button
  const history = useHistory();
  const toggleDrawer = () => {
    setVisible(!visible); // Toggle visibility state
  };
  useEffect(() => {
    const unlisten = history.listen((_, action) => {
      if (action === 'POP') {
        setVisible(false);
      }
    });
    return unlisten;
  }, [history]);
  const categoryHandle = (ids) => {
    const id = ids.join(",");
    setFilter((filter) => {
      return { ...filter, category_ids: id };
    });
  };

  useEffect(() => {
    document.getElementsByClassName("ant-select-selector")[1].style.border =
      "1px solid #F2F2F2";
    document.getElementsByClassName(
      "ant-select-selector"
    )[1].style.borderRadius = "26px";
    document.getElementsByClassName(
      "ant-select-selector"
    )[1].style.backgroundColor = "#F2F2F2";
    document.getElementsByClassName("ant-select-selector")[1].style.height =
      "40px";
    document.getElementsByClassName(
      "ant-select-selection-placeholder"
    )[0].style.color = "black";
  }, []);

  const orientationClick = (buttonNumber) => {
    setorientationButton(buttonNumber); // Sets the active button
  };

  const sortByClick = (buttonNumber) => {
    setSortByButton(buttonNumber);
  };

  const setResetFilter = () => {
    setorientationButton(null);
    setSortByButton(null);
    getFilterSortParams("filterSort", "default");
    setFilter({
      search_key: null,
      tag_ids: null,
      category_ids: null,
      tobacco_status: 1,
      sort_by: "created_at:desc",
    });
    formRef.current.value = "";
    formRef.current.tree = [];
  };

  const productSearchLocal = JSON.parse(localStorage.getItem("shop_search_filters") || '{}');

  const handleSorting = (value) => {
    setFilter((filters) => {
      let updatedFilters;
  
      if (value === "1") {
        updatedFilters = {
          ...filters,
          sort_by: "",
          is_variant_group: "1",
        };
      } else {
        updatedFilters = {
          ...filters,
          sort_by: value,
          is_variant_group: "0",
        };
  
        if (productSearchLocal?.search_filter) {
          productSearchLocal.search_filter.sort_by = value;
          localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
        }
      }
  
      return updatedFilters;
    });
  };
  
const persistedFiltersString = localStorage.getItem("shop_search_filters");
const persistedFilters = persistedFiltersString ? 
  JSON.parse(persistedFiltersString) : {};
  
  return (
    <>
      <div className="shop-top-bar mb-5">
        <div style={{display:"flex"}}>
      {
        persistedFilters?.search_filter?.category_ids && (
          <>
              <h1 className="shop-page-main-cat" style={{
              display: `${sidebarFilter == "active" ? "contents" : "none"}`,
            }}>
                {mapCategoryTreeData()}
              </h1>
          </>
        )
      }
        <div className="select-shoing-wrap">
          <div
            style={{
              display: `${sidebarFilter == "active" ? "none" : "contents"}`,
            }}
          >
            <div className="filter-display-reponsive">
              <button
                className="filter-button"
                onClick={(e) => { getSidebarFilter("active"); }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M7.50065 4.16871C7.27964 4.16871 7.06768 4.25651 6.9114 4.41279C6.75512 4.56907 6.66732 4.78103 6.66732 5.00204C6.66732 5.22306 6.75512 5.43502 6.9114 5.5913C7.06768 5.74758 7.27964 5.83538 7.50065 5.83538C7.72166 5.83538 7.93363 5.74758 8.08991 5.5913C8.24619 5.43502 8.33398 5.22306 8.33398 5.00204C8.33398 4.78103 8.24619 4.56907 8.08991 4.41279C7.93363 4.25651 7.72166 4.16871 7.50065 4.16871ZM5.14232 4.16871C5.31449 3.68076 5.63377 3.25824 6.05615 2.95937C6.47853 2.6605 6.98322 2.5 7.50065 2.5C8.01808 2.5 8.52277 2.6605 8.94515 2.95937C9.36753 3.25824 9.68682 3.68076 9.85898 4.16871H15.834C16.055 4.16871 16.267 4.25651 16.4232 4.41279C16.5795 4.56907 16.6673 4.78103 16.6673 5.00204C16.6673 5.22306 16.5795 5.43502 16.4232 5.5913C16.267 5.74758 16.055 5.83538 15.834 5.83538H9.85898C9.68682 6.32332 9.36753 6.74585 8.94515 7.04472C8.52277 7.34359 8.01808 7.50408 7.50065 7.50408C6.98322 7.50408 6.47853 7.34359 6.05615 7.04472C5.63377 6.74585 5.31449 6.32332 5.14232 5.83538H4.16732C3.9463 5.83538 3.73434 5.74758 3.57806 5.5913C3.42178 5.43502 3.33398 5.22306 3.33398 5.00204C3.33398 4.78103 3.42178 4.56907 3.57806 4.41279C3.73434 4.25651 3.9463 4.16871 4.16732 4.16871H5.14232ZM12.5007 9.16871C12.2796 9.16871 12.0677 9.25651 11.9114 9.41279C11.7551 9.56907 11.6673 9.78103 11.6673 10.002C11.6673 10.2231 11.7551 10.435 11.9114 10.5913C12.0677 10.7476 12.2796 10.8354 12.5007 10.8354C12.7217 10.8354 12.9336 10.7476 13.0899 10.5913C13.2462 10.435 13.334 10.2231 13.334 10.002C13.334 9.78103 13.2462 9.56907 13.0899 9.41279C12.9336 9.25651 12.7217 9.16871 12.5007 9.16871ZM10.1423 9.16871C10.3145 8.68076 10.6338 8.25824 11.0562 7.95937C11.4785 7.6605 11.9832 7.5 12.5007 7.5C13.0181 7.5 13.5228 7.6605 13.9452 7.95937C14.3675 8.25824 14.6868 8.68076 14.859 9.16871H15.834C16.055 9.16871 16.267 9.25651 16.4232 9.41279C16.5795 9.56907 16.6673 9.78103 16.6673 10.002C16.6673 10.2231 16.5795 10.435 16.4232 10.5913C16.267 10.7476 16.055 10.8354 15.834 10.8354H14.859C14.6868 11.3233 14.3675 11.7458 13.9452 12.0447C13.5228 12.3436 13.0181 12.5041 12.5007 12.5041C11.9832 12.5041 11.4785 12.3436 11.0562 12.0447C10.6338 11.7458 10.3145 11.3233 10.1423 10.8354H4.16732C3.9463 10.8354 3.73434 10.7476 3.57806 10.5913C3.42178 10.435 3.33398 10.2231 3.33398 10.002C3.33398 9.78103 3.42178 9.56907 3.57806 9.41279C3.73434 9.25651 3.9463 9.16871 4.16732 9.16871H10.1423ZM7.50065 14.1687C7.27964 14.1687 7.06768 14.2565 6.9114 14.4128C6.75512 14.5691 6.66732 14.781 6.66732 15.002C6.66732 15.2231 6.75512 15.435 6.9114 15.5913C7.06768 15.7476 7.27964 15.8354 7.50065 15.8354C7.72166 15.8354 7.93363 15.7476 8.08991 15.5913C8.24619 15.435 8.33398 15.2231 8.33398 15.002C8.33398 14.781 8.24619 14.5691 8.08991 14.4128C7.93363 14.2565 7.72166 14.1687 7.50065 14.1687ZM5.14232 14.1687C5.31449 13.6808 5.63377 13.2582 6.05615 12.9594C6.47853 12.6605 6.98322 12.5 7.50065 12.5C8.01808 12.5 8.52277 12.6605 8.94515 12.9594C9.36753 13.2582 9.68682 13.6808 9.85898 14.1687H15.834C16.055 14.1687 16.267 14.2565 16.4232 14.4128C16.5795 14.5691 16.6673 14.781 16.6673 15.002C16.6673 15.2231 16.5795 15.435 16.4232 15.5913C16.267 15.7476 16.055 15.8354 15.834 15.8354H9.85898C9.68682 16.3233 9.36753 16.7458 8.94515 17.0447C8.52277 17.3436 8.01808 17.5041 7.50065 17.5041C6.98322 17.5041 6.47853 17.3436 6.05615 17.0447C5.63377 16.7458 5.31449 16.3233 5.14232 15.8354H4.16732C3.9463 15.8354 3.73434 15.7476 3.57806 15.5913C3.42178 15.435 3.33398 15.2231 3.33398 15.002C3.33398 14.781 3.42178 14.5691 3.57806 14.4128C3.73434 14.2565 3.9463 14.1687 4.16732 14.1687H5.14232Z" fill="var(--style-primary-color)"/>
                </svg>
                Filters
              </button>
            </div>
            <div className="filter-responsive">
              <div className="filter-mobile-display-reponsive">
                <Drawer
                  placement="top"
                  closable={true}
                  visible={visible} // Controlled by state
                  closeIcon={false}
                  onClose={() => toggleDrawer(0, false)}
                  headerStyle={{ display: "none" }}
                  size="large"
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex" }}>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/media/icons/crossicon.svg"
                        }
                        alt="sidebar icon"
                        style={{
                          cursor: "pointer",
                          padding: "8.926px 8.939px 8.926px 8.94px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={toggleDrawer}
                      />
                      <div style={{ Font: "Montserrat", Weight: 400, fontSize: "24px", lineHeight: "32px" }}>
                        Filters
                      </div>
                    </div>
                    {/* <div>
                      <button
                        style={{
                          width: "100%",
                          borderRadius: "54px",
                          border: "none",
                          gap: "10px",
                          color: "#4C4C4C",
                          fontSize: "15px",
                          lineHeight: "20px",
                          marginLeft: "10px",
                        }}
                        onClick={setResetFilter}
                      >
                        Clear All
                      </button>
                    </div> */}
                  </div>
                  <ShopSidebar
                    getLayout={getLayout}
                    getFilterSortParams={getFilterSortParams}
                    getSortParams={getSortParams}
                    setFilter={setFilter}
                    filters={filters}
                    orientationClick={orientationClick}
                    sortByClick={sortByClick}
                    orientationButton={orientationButton}
                    sortByButton={sortByButton}
                    formRef={formRef}
                    setVisible={setVisible} 
                    searchTag={searchTag}
                    setSearchTag={setSearchTag}
                    setSelectedBrands={setSelectedBrands}
                    selectedBrands={selectedBrands}
                  />
                </Drawer>
                <button
                  className="filter-button"
                  onClick={toggleDrawer}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.50065 4.16871C7.27964 4.16871 7.06768 4.25651 6.9114 4.41279C6.75512 4.56907 6.66732 4.78103 6.66732 5.00204C6.66732 5.22306 6.75512 5.43502 6.9114 5.5913C7.06768 5.74758 7.27964 5.83538 7.50065 5.83538C7.72166 5.83538 7.93363 5.74758 8.08991 5.5913C8.24619 5.43502 8.33398 5.22306 8.33398 5.00204C8.33398 4.78103 8.24619 4.56907 8.08991 4.41279C7.93363 4.25651 7.72166 4.16871 7.50065 4.16871ZM5.14232 4.16871C5.31449 3.68076 5.63377 3.25824 6.05615 2.95937C6.47853 2.6605 6.98322 2.5 7.50065 2.5C8.01808 2.5 8.52277 2.6605 8.94515 2.95937C9.36753 3.25824 9.68682 3.68076 9.85898 4.16871H15.834C16.055 4.16871 16.267 4.25651 16.4232 4.41279C16.5795 4.56907 16.6673 4.78103 16.6673 5.00204C16.6673 5.22306 16.5795 5.43502 16.4232 5.5913C16.267 5.74758 16.055 5.83538 15.834 5.83538H9.85898C9.68682 6.32332 9.36753 6.74585 8.94515 7.04472C8.52277 7.34359 8.01808 7.50408 7.50065 7.50408C6.98322 7.50408 6.47853 7.34359 6.05615 7.04472C5.63377 6.74585 5.31449 6.32332 5.14232 5.83538H4.16732C3.9463 5.83538 3.73434 5.74758 3.57806 5.5913C3.42178 5.43502 3.33398 5.22306 3.33398 5.00204C3.33398 4.78103 3.42178 4.56907 3.57806 4.41279C3.73434 4.25651 3.9463 4.16871 4.16732 4.16871H5.14232ZM12.5007 9.16871C12.2796 9.16871 12.0677 9.25651 11.9114 9.41279C11.7551 9.56907 11.6673 9.78103 11.6673 10.002C11.6673 10.2231 11.7551 10.435 11.9114 10.5913C12.0677 10.7476 12.2796 10.8354 12.5007 10.8354C12.7217 10.8354 12.9336 10.7476 13.0899 10.5913C13.2462 10.435 13.334 10.2231 13.334 10.002C13.334 9.78103 13.2462 9.56907 13.0899 9.41279C12.9336 9.25651 12.7217 9.16871 12.5007 9.16871ZM10.1423 9.16871C10.3145 8.68076 10.6338 8.25824 11.0562 7.95937C11.4785 7.6605 11.9832 7.5 12.5007 7.5C13.0181 7.5 13.5228 7.6605 13.9452 7.95937C14.3675 8.25824 14.6868 8.68076 14.859 9.16871H15.834C16.055 9.16871 16.267 9.25651 16.4232 9.41279C16.5795 9.56907 16.6673 9.78103 16.6673 10.002C16.6673 10.2231 16.5795 10.435 16.4232 10.5913C16.267 10.7476 16.055 10.8354 15.834 10.8354H14.859C14.6868 11.3233 14.3675 11.7458 13.9452 12.0447C13.5228 12.3436 13.0181 12.5041 12.5007 12.5041C11.9832 12.5041 11.4785 12.3436 11.0562 12.0447C10.6338 11.7458 10.3145 11.3233 10.1423 10.8354H4.16732C3.9463 10.8354 3.73434 10.7476 3.57806 10.5913C3.42178 10.435 3.33398 10.2231 3.33398 10.002C3.33398 9.78103 3.42178 9.56907 3.57806 9.41279C3.73434 9.25651 3.9463 9.16871 4.16732 9.16871H10.1423ZM7.50065 14.1687C7.27964 14.1687 7.06768 14.2565 6.9114 14.4128C6.75512 14.5691 6.66732 14.781 6.66732 15.002C6.66732 15.2231 6.75512 15.435 6.9114 15.5913C7.06768 15.7476 7.27964 15.8354 7.50065 15.8354C7.72166 15.8354 7.93363 15.7476 8.08991 15.5913C8.24619 15.435 8.33398 15.2231 8.33398 15.002C8.33398 14.781 8.24619 14.5691 8.08991 14.4128C7.93363 14.2565 7.72166 14.1687 7.50065 14.1687ZM5.14232 14.1687C5.31449 13.6808 5.63377 13.2582 6.05615 12.9594C6.47853 12.6605 6.98322 12.5 7.50065 12.5C8.01808 12.5 8.52277 12.6605 8.94515 12.9594C9.36753 13.2582 9.68682 13.6808 9.85898 14.1687H15.834C16.055 14.1687 16.267 14.2565 16.4232 14.4128C16.5795 14.5691 16.6673 14.781 16.6673 15.002C16.6673 15.2231 16.5795 15.435 16.4232 15.5913C16.267 15.7476 16.055 15.8354 15.834 15.8354H9.85898C9.68682 16.3233 9.36753 16.7458 8.94515 17.0447C8.52277 17.3436 8.01808 17.5041 7.50065 17.5041C6.98322 17.5041 6.47853 17.3436 6.05615 17.0447C5.63377 16.7458 5.31449 16.3233 5.14232 15.8354H4.16732C3.9463 15.8354 3.73434 15.7476 3.57806 15.5913C3.42178 15.435 3.33398 15.2231 3.33398 15.002C3.33398 14.781 3.42178 14.5691 3.57806 14.4128C3.73434 14.2565 3.9463 14.1687 4.16732 14.1687H5.14232Z" fill="var(--style-primary-color)"/>
                  </svg>
                </button>
              </div>
            </div>
            <div style={{ width: "181px", marginLeft: "20px", display: "none", }}>
              <div className="filter-display-reponsive">
                <Select
                  showSearch
                  value={categoryName}
                  className="ant-select-selector"
                  optionFilterProp="label"
                  showArrow
                  mode="multiple"
                  allowClear
                  maxTagTextLength={10}
                  placeholder={"Category"}
                  maxTagCount={"responsive"}
                  filterOption={false}
                  onChange={(e, c) => {
                    categoryHandle(e);
                    setCategoryName(c.children);
                  }}
                >
                  {categoryTreeData?.length !== 0
                    && categoryTreeData?.map((category) => (
                      <Option value={category?.id}>{category?.name}</Option>
                    ))}
                </Select>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div className="mobile-hide shop-tab filter-display-reponsive" style={{display:"flex", justifyContent:"space-between"}}>
          <button
            onClick={(e) => {
              getLayout("grid three-column");
              setActiveLayout(e);
            }}
            style={{ display: "flex", marginRight: "10px" }}
          >

            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="32"
               height="32"
               viewBox="0 0 32 32"
               fill="none"
               class={`svg-icon ${layout === "grid three-column" ? 'active' : ''}`}
            >
              <path d="M4.21 5.33008C3.62387 5.33008 3.06175 5.56292 2.64729 5.97737C2.23284 6.39183 2 6.95395 2 7.54008V16.4601C2 17.0462 2.23284 17.6083 2.64729 18.0228C3.06175 18.4372 3.62387 18.6701 4.21 18.6701H6V5.33008H4.21Z"/>
              <path d="M19.79 5.33008H18V18.6701H19.8C20.3844 18.6674 20.9439 18.4334 21.3562 18.0193C21.7685 17.6051 22 17.0445 22 16.4601V7.54008C22 6.95395 21.7672 6.39183 21.3527 5.97737C20.9383 5.56292 20.3761 5.33008 19.79 5.33008Z"/>
              <g opacity="0.3">
              <path d="M15 2H9C8.20435 2 7.44129 2.31607 6.87868 2.87868C6.31607 3.44129 6 4.20435 6 5V19.1C6.02595 19.8782 6.35345 20.6158 6.91327 21.157C7.47309 21.6981 8.22138 22.0004 9 22H15C15.7871 22.0001 16.5426 21.6909 17.1038 21.1391C17.665 20.5872 17.9869 19.837 18 19.05V5C18 4.20435 17.6839 3.44129 17.1213 2.87868C16.5587 2.31607 15.7956 2 15 2Z"/>
              </g>
            </svg>
          </button>
          <img style={{ height: "25px" }}
            src={
              `${process.env.PUBLIC_URL}/media/icons/Line 9.png`
            }
          />
          <button
            onClick={(e) => {
              getLayout("grid two-column");
              setActiveLayout(e);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              class={`svg-icon ${layout === "grid two-column" ? 'active' : ''}`}
            >
              <g opacity="0.3">
                <path
                  d="M18.28 4.59961H5.72C4.07971 4.59961 2.75 5.92932 2.75 7.56961V16.4296C2.75 18.0699 4.07971 19.3996 5.72 19.3996H18.28C19.9203 19.3996 21.25 18.0699 21.25 16.4296V7.56961C21.25 5.92932 19.9203 4.59961 18.28 4.59961Z"/>
              </g>
              <path
                d="M18.7398 3.5H5.25977C5.06085 3.5 4.87009 3.42098 4.72944 3.28033C4.58878 3.13968 4.50977 2.94891 4.50977 2.75C4.50977 2.55109 4.58878 2.36032 4.72944 2.21967C4.87009 2.07902 5.06085 2 5.25977 2H18.7398C18.9387 2 19.1294 2.07902 19.2701 2.21967C19.4107 2.36032 19.4898 2.55109 19.4898 2.75C19.4898 2.94891 19.4107 3.13968 19.2701 3.28033C19.1294 3.42098 18.9387 3.5 18.7398 3.5Z"/>
              <path
                d="M18.7398 22H5.25977C5.06085 22 4.87009 21.921 4.72944 21.7803C4.58878 21.6397 4.50977 21.4489 4.50977 21.25C4.50977 21.0511 4.58878 20.8603 4.72944 20.7197C4.87009 20.579 5.06085 20.5 5.25977 20.5H18.7398C18.9387 20.5 19.1294 20.579 19.2701 20.7197C19.4107 20.8603 19.4898 21.0511 19.4898 21.25C19.4898 21.4489 19.4107 21.6397 19.2701 21.7803C19.1294 21.921 18.9387 22 18.7398 22Z"/>
            </svg>
          </button>
        </div>
      </div>
      <div className="shop-top-bar">
        <p style={{ marginBottom: "0px" }}>
          Showing {sortedProductCount} of {productCount} result
        </p>
        <div className="sort-filter-respnsive">
          <p style={{ display: "contents", fontWeight: 100, color: "#808080", }}>Sort By:</p>
          <div
            className="shop-select"
            style={{
              fontSize: "14px",
              color: "#333",
              // border: "2px solid #f2f2f2",
              // backgroundColor: "#f2f2f2",
              borderRadius: "27px",
              paddingLeft: "4px",
              paddingRight: "24px",
            }}
          >
            <select
              onChange={(e) =>
                handleSorting( e.target.value)
              }
            >
              <option value="price:desc">Price - High to Low</option>
              <option value="price:asc">Price - Low to High</option>
              <option value="name:asc">Name (A to Z)</option>
              <option value="name:desc">Name (Z to A)</option>
            </select>
          </div>
          <p style={{ display: "contents", fontWeight: 100, color: "#808080", }}>Product Count:</p>
          <div
            className="shop-select"
            style={{
              fontSize: "14px",
              color: "#333",
              // border: "2px solid #f2f2f2",
              // backgroundColor: "#f2f2f2",
              borderRadius: "27px",
              paddingLeft: "4px",
              paddingRight: "10px",
              marginLeft: "4px",
            }}
          >
            <select onChange={(e) => getItemsPerPage(e.target.value)}>
              <option value="100">100</option>
              <option value="50">50</option>
              <option value="25">25</option>
              <option value="15">15</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    categoryTreeData: state.categoryData.entities,
  };
};

export default connect(mapStateToProps)(ShopTopAction);
